export default "__VITE_ASSET__DzXW8IXt__"